import React, {Component} from 'react';
import {connect} from 'react-redux';
import {goBack, push} from 'react-router-redux';

import {linkSubscribe, AuthConfig} from './../../../conf/config';

import {hideBlockedCommentPopup, getArticleContent, getFakeArticleContent} from './../articleActions';

import Layout from './../../../hoc/Layout/Layout';
import Header from './../../../containers/Navigation/Header/Header';
import Footer from './../../../containers/Navigation/Footer/Footer';

//-- Containers
import Comment from './../../../containers/Comment/Comment';
import ChatButton from './../../../components/UI/Common/ChatButton/ChatButton';
import ClickableIcon from './../../../containers/UI/ClickableIcon/ClickableIcon';
import EmojiWheel from './../../../components/EmojiWheel/EmojiWheel';
import QuizzBlock from './../../../containers/Article/Details/QuizzBlock';
import CoverBlock from './../../../containers/Article/Details/CoverBlock';
import DoubleHalfCircle from './../../../containers/UI/Common/Shapes/DoubleHalfCircle';
import Zigzag from './../../../containers/UI/Common/Shapes/Zigzag';
import Aux from './../../../hoc/_Aux';

//-- formulaire
import MailInvitationForm from './../../forms/mailInvitationForm';

// for animation 
import anime from 'animejs';

import * as constantArticle from './../../../conf/constantArticle';
import JobBlock from './../../../containers/Article/Details/JobBlock';
import MessageModal from './../../../containers/UI/MessageModal/MessageModal';

//-- Utils
import {pushHeaderTitle} from '../../../utils/dom/helper';
import {pushPageView} from '../../../utils/tracking/customGtm';

// assets
import TinyJellyShape from './../../../containers/UI/Common/JellyShape/TinyJellyShape';
import BackBtnArrow from './../../../assets/images/icons/fleche_retour.svg';
import BurgerMenu from './../../../assets/images/icons/burger.svg';
import Button from "../../../containers/UI/Button/Button";


class ArticleDetails extends Component {

    state = {
        closeReactionWheel: false,
        pageHeightVisible: 0,
    }

    // properties used for managing bind event
    isAnimating = false;
    lastScrollTop = 0;
    touchObject = {};
    animTimeline = null;

    componentWillMount() {

        //if we do not have article's data and we are not connected we redirect to /discover
        if (!this.props.isUserSignedIn && Object.keys(this.props.content).length === 0) {
            this.props.goToDiscoverPage();
            return;
        }

        window.scrollTo(0, 0); // force when loading article to scroll on top

        //for each html block we process the html content to find the scripts and include them inside the dom
        //they will be initialised during the rendering
        for (let i = 0; i < this.props.content.blocks; i++) {
            if (this.props.content.blocks[i].type === 5) {
                //we add the script to the dom
                this.processHtmlContent(this.props.content.blocks[i].content);
            }
        }

        // set the window's height visible on WillMount
        if (parseInt(window.innerHeight, 10) > 0) {
            this.setState({pageHeightVisible: parseInt(window.innerHeight, 10)});
        }
    }

    componentDidMount() {

        const id = this.props.pathname.split('-').pop();
        console.log("TEST", id, this.props.content);

        this.props.getArticle(id);

        //-- Update title
        if (typeof this.props.content !== 'undefined' && this.props.content.hasOwnProperty('title')) {
            pushHeaderTitle(this.props.content.title);
        }

        //-- Push GTM page view
        pushPageView();

        //-- Define footer classes
        this._defineFooterClass();

        // bind scroll event
        window.addEventListener('scroll', this.handleScroll);

        // binds touch events for mobile
        window.addEventListener('touchstart', this.handleStart);
        window.addEventListener('touchmove', this.handleMove);
        window.addEventListener('touchend', this.handleSwipe);
    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);

        window.removeEventListener('touchstart', this.handleStart);
        window.removeEventListener('touchmove', this.handleMove);
        window.removeEventListener('touchend', this.handleSwipe);
    };

    noScroll = () => {
        window.scrollTo(0, 0);
    }

    scrollToSection = (evt, targetHeight) => {
        evt.preventDefault();

        const scrollCoords = {
            y: window.pageYOffset
        }

        // using AnimeJS library
        this.animTimeline = anime({
            targets: scrollCoords,
            y: targetHeight,
            duration: 1000,
            easing: 'easeInOutCubic',
            update: () => window.scroll(0, scrollCoords.y),
            complete: () => {
                this.isAnimating = false;
                this.lastScrollTop = targetHeight - 1;
                // when returning to the top, we need to hide the footer bar
                if (this.lastScrollTop <= 0) {
                    const footer = document.querySelectorAll('.article-footer');
                    Array.from(footer).map((el => {
                        el.classList.remove('reveal');

                        return el;
                    }));
                }
                window.addEventListener('scroll', this.handleScroll);
            }
        })
    }


    handleScroll = (event) => {
        //const top = document.documentElement.scrollTop || document.body.scrollTop;

        //const scrollHeight  = document.documentElement.scrollHeight || document.body.scrollHeight;

        this._defineFooterClass();

        //console.log('current : '+scrollHeight+' | '+this.lastScrollTop+ ' isAnim='+this.isAnimating);

        // if(top > 0  && top < this.state.pageHeightVisible){
        /*
        if(scrollHeight > this.lastScrollTop && !this.isAnimating){
            window.scrollTo(0, 0); // force to block to scroll

            this.isAnimating = true;
            window.removeEventListener('scroll', this.handleScroll);
            this.scrollToSection(event,this.state.pageHeightVisible+1);
        }

        else if (scrollHeight < this.lastScrollTop && !this.isAnimating){
            this.isAnimating = true;
            window.removeEventListener('scroll', this.handleScroll);
            this.scrollToSection(event,0);
        }*/
        // }

        // this.lastScrollTop = scrollHeight <= 0 ? 0 : scrollHeight;
    }

    _defineFooterClass = () => {
        const stickyFooter = document.querySelectorAll('.article-footer');
        let footerElement = Array.from(stickyFooter);

        const top = document.documentElement.scrollTop || document.body.scrollTop;
        const widthDoc = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

        footerElement.map(el => {

            if (top > 100 || widthDoc >= 1280) {
                el.classList.add('reveal');
                this.setState({closeReactionWheel: false});
            } else {
                el.classList.remove('reveal');
                this.setState({closeReactionWheel: true});
            }

            return el;
        });
    }

    handleStart = (e) => {
        this.touchObject = {
            startX: e.touches[0].pageX,
            startY: e.touches[0].pageY
        };
    }

    swipeDirection(x1, x2, y1, y2) {
        const xDist = x1 - x2;
        const yDist = y1 - y2;
        const r = Math.atan2(yDist, xDist);
        let swipeAngle = Math.round(r * 180 / Math.PI);

        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        //console.log('a ='+swipeAngle);
        if (swipeAngle <= 179 && swipeAngle >= 0) {
            return -1;
        }
        if (swipeAngle <= 360 && swipeAngle >= 181) {
            return 1;
        }
    }

    handleMove = (e) => {
        const direction = this.swipeDirection(
            this.touchObject.startX,
            e.touches[0].pageX,
            this.touchObject.startY,
            e.touches[0].pageY
        );

        if (direction !== 0) {
            // e.preventDefault() // does not work here, return a weird warning message
            return false;
        }

        this.touchObject = {
            startX: e.touches[0].pageX,
            startY: e.touches[0].pageY,
            direction: direction
        };
    }

    handleSwipe = (e) => {
        if (this.touchObject.startY > 0 && this.touchObject.startY < this.state.pageHeightVisible) {
            if (this.touchObject.direction === 1) {
                this.scrollToSection(e, this.state.pageHeightVisible + 1);
            }
        }
    }

    closeModalHandler = () => {
        this.props.onCloseModal();
    }

    backButtonClickHandler = () => {
        //Fix bug here when user is going back to hp when scrolling animation is on, we force to pause the animation here
        if (this.animTimeline !== null && typeof this.animTimeline !== 'undefined' && this.animTimeline.paused !== true) {
            this.animTimeline.pause();
        }
        this.props.onBackArticleClicked();
    }

    onClickSubscribeHandler = (event) => {
        event.preventDefault();
        window.open(linkSubscribe, '_blank');
    }

    onCloseTryOutPopup = () => {
        this.props.onCloseTryOutModal();
    }

    onClickGoToLogin = () => {
        this.props.onClickGoLogin();
    }

    /*****************************
     *         RENDERERS         *
     *****************************/

    /**
     * Render for article cover
     *
     * @param mainImageBlocId : index of first picture found on block list
     * @param coverBgStyle : Background cover image article
     *
     * @return JSX object : Return cover containement
     */
    _renderCoverBlock = (mainImageBlocId, coverBgStyle) => {
        const thematicName = (typeof this.props.thematic !== 'undefined') ? this.props.thematic : '';

        if (
            typeof this.props.content !== 'undefined' &&
            this.props.content.hasOwnProperty('document_type') &&
            //-- Check if this article is doc, image or video type
            [
                constantArticle.CONTENT_TYPE_DOC,
                constantArticle.CONTENT_TYPE_IMAGE,
                constantArticle.CONTENT_TYPE_VIDEO
            ].includes(parseInt(this.props.content.document_type, 10))
        ) {

            return <CoverBlock
                key={'content-article-cover'}
                coverBgStyle={coverBgStyle}
                mainImageBlockId={mainImageBlocId}
                thematicName={thematicName}
                title={this.props.content.title}
                author={this.props.content.credits.name}
                likes={this.props.likes}
            />;
        }

        return [];
    };

    /**
     * Render for excerpt block
     *
     * @param excerptString : Excerpt of article
     *
     * @return JSX object ; Return exceprt on jsx containement
     */
    _renderExcerptBlock = (excerptString) => {
        return (
            <div key={`content-article-exceprt`} className="excerpt-summary">
                {excerptString}
            </div>);
    };

    /**
     * (Obsolete) Render on two column with sticky anchor images at left
     *
     * @param stickyLeft : All images left column
     * @param contentBlocks : All blocks containement
     *
     * @return JSX object : Return all formated containement
     */
    _renderContentBlocksObsolete = (stickyLeft, contentBlocks) => {
        return stickyLeft.map((bgStyle, index) => {
            return (
                <div key={`block-limit-sticky-${index}`} className={'block-limit-sticky'}>
                    <div key={`block-limit-sticky-${index}-sticky-container`} className={'sticky-container'}>
                        <div key={`block-limit-sticky-${index}-sticky`} className={'sticky-img'} style={bgStyle}></div>
                    </div>
                    <div key={`block-limit-sticky-${index}-container`}
                         className={'filled-container'}>{contentBlocks[index]}</div>
                </div>
            )
        })
    }

    /**
     * Render on two column with sticky cover main picture article at left
     *
     * @param stickyLeft : All images left column
     * @param contentBlocks : All blocks containement
     *
     * @return JSX object : Return all formated containement
     */
    _renderContentBlocks = (stickyLeft, contentBlocks) => {
        if (stickyLeft.length === 0) return '';

        const bgStyle = stickyLeft[0];
        return (
            <div key={`block-limit-sticky`} className={'block-limit-sticky'}>
                <div key={`block-limit-sticky-sticky-container`} className="sticky-container">
                    <div key={`block-limit-sticky-sticky`} className={'sticky-img'} style={bgStyle}>
                        <ClickableIcon name="backBtn2" class="icon-back-btn" iconPath={BackBtnArrow}
                                       action={this.backButtonClickHandler}/>
                        <div key={`block-limit-sticky-sticky-halcircle`} className="dual-half-circle">
                            <DoubleHalfCircle color1='#fff' color2='#fcea10' rotateAngle="0"/>
                        </div>
                    </div>
                </div>
                <div key={`block-limit-sticky-filled-container`}
                     className={`filled-container ${this.props.isUserSignedIn ? '' : 'blur'}`}>
                    {contentBlocks.map((content) => {
                        return content;
                    })}
                </div>
            </div>);

    }

    //----------------
    //-- Helper render

    /**
     * Helper for get background cover style for a block-img
     *
     * @param int indexImg : index of targeted block
     *
     * @return {object} : Return css object with background properties
     */
    _getBlockImgBackgroundStyle = (indexImg) => {
        return {
            'background': `url(${this.props.imageHelper(this.props.content.blocks[indexImg].content, '900w')}) 50% 50% no-repeat`,
            'backgroundSize': 'cover',
        };
    }

    /**
     * Search main image for this article
     *
     * @return int : Return block who have main picture
     */
    _defineMainImageBlock = () => {
        //-- If nothing is found on content props, we return 0
        if (typeof this.props.content === 'undefined' || typeof this.props.content.blocks === 'undefined') {
            return 0;
        }

        //-- We need to find the first image of article
        for (const indexBlock in this.props.content.blocks) {
            const blockInfo = this.props.content.blocks[indexBlock];
            if (parseInt(blockInfo.type, 10) === constantArticle.CONTENT_TYPE_IMAGE) {
                return indexBlock;
            }
        }
    };

    /**
     * test if a script has already been included in the dom
     */
    isScriptAlreadyIncluded = (src) => {
        var scripts = document.getElementsByTagName("script");
        for (var i = 0; i < scripts.length; i++)
            if (scripts[i].src === src) return true;

        return false;
    }

    /**
     * find the script part in an embed html content and insert it in the document's body if it's not
     *
     * @return {string} : Return the html content processed
     */
    processHtmlContent = (htmlContent) => {

        var regex = /<script.*><\/script>/;
        var scriptTagArray = htmlContent.match(regex);

        if (scriptTagArray === null) {
            return htmlContent;
        }

        var scriptTag = scriptTagArray[0];
        var scriptTagValue = scriptTag.substring(7, scriptTag.length - 10);
        var arrayValue = scriptTagValue.split(' ');
        //we start to 1 because the first value is empty

        const s = document.createElement('script');
        s.type = 'text/javascript';
        for (let i = 1; i < arrayValue.length; i++) {
            let datas = arrayValue[i].replace(/\"/g, '').split("=");
            s[datas[0]] = typeof datas[1] !== 'undefined' ? datas[1] : false;
        }

        if (!this.isScriptAlreadyIncluded(s.src)) //if the script isn't already in the document body
        {
            document.body.appendChild(s);
        } else { //if the script is in dom, we have to check if it's initialized
            switch (s.src) {
                case 'https://platform.twitter.com/widgets.js':
                    //if the script is not initialized, we initialized it
                    if (typeof window.twttr !== 'undefined' && typeof window.twttr.widgets !== 'undefined'
                        && typeof document.getElementsByClassName("twitter-tweet")[0] !== 'undefined'
                        && document.getElementsByClassName("twitter-tweet")[0].nodeName === "BLOCKQUOTE") { //the node name change from BlockQuote to iframe when it's loaded
                        window.twttr.widgets.load();
                    }
                    break;
                case 'https://www.instagram.com/embed.js':
                    if (typeof window.instgrm !== 'undefined' && typeof window.instgrm.Embeds !== 'undefined'
                        && typeof document.getElementsByClassName("instagram-media")[0] !== 'undefined'
                        && document.getElementsByClassName("instagram-media")[0].nodeName === "BLOCKQUOTE") { //the node name change from BlockQuote to iframe when it's loaded
                        window.instgrm.Embeds.process();
                    }
                    break;
                case 'https://sdk.canva.com/v1/embed.js': //We don't do anything now since the script can't be initialized. In case that change it's here
                    break;
            }
        }

        htmlContent = htmlContent.replace(regex, '');

        return htmlContent;
    }

    /**
     * Define content splited on two column
     *
     * @return {object} : Return two column
     *  - stickyLeft : All images blocks,
     *  - contentBlocks : All column spit for each image
     */
    _defineContentOutput = () => {
        let lockedBlockMapping = [];

        let mainImageBlocId = this._defineMainImageBlock();
        const coverBgStyle = this._getBlockImgBackgroundStyle(mainImageBlocId);
        let coverOutput = this._renderCoverBlock(mainImageBlocId, coverBgStyle);

        let excerptContent = [];
        if (typeof this.props.content !== 'undefined' && this.props.content.hasOwnProperty('excerpt')) {
            excerptContent = this._renderExcerptBlock(this.props.content.excerpt);
        }

        const stickyLeft = [coverBgStyle];
        const contentBlocks = [[coverOutput, excerptContent]];

        if (typeof this.props.content !== 'undefined' && this.props.content.hasOwnProperty('blocks')) {


            this.props.content.blocks.forEach((blockData, index) => {
                //-- Stop display
                if (
                    //- Quizz need to be answered before displaying the next block
                    lockedBlockMapping.length > 0 ||
                    //- Current block is cover image
                    parseInt(mainImageBlocId, 10) === parseInt(index, 10)
                ) {
                    return (''); // following block(s) are not displayed
                }

                let blockClasses = [`block-${index + 1}`];
                let htmlContent = null;
                let content = '';

                switch (parseInt(blockData.type, 10)) {
                    //-- Display an image block
                    case constantArticle.CONTENT_TYPE_IMAGE :
                        let imgURL = '';
                        if (typeof this.props.imageHelper === 'function' && blockData.content !== '') {
                            imgURL = this.props.imageHelper(blockData.content, '900w');
                        }

                        blockClasses.push('block-img');

                        stickyLeft.push(this._getBlockImgBackgroundStyle(index));
                        contentBlocks.push([]);

                        content = (
                            <div key={`content-block-index-${index}`} className={blockClasses.join(' ')}>
                                <img key={`content-block-index-${index}`} src={imgURL} alt=""/>
                            </div>
                        );
                        break;
                    case constantArticle.CONTENT_TYPE_DOC :
                        blockClasses.push('block-text');
                        htmlContent = blockData.content;

                        content = (
                            <div key={`content-block-index-${index}`} className={blockClasses.join(' ')}
                                 dangerouslySetInnerHTML={{__html: htmlContent}}/>
                        );
                        break;
                    case constantArticle.CONTENT_TYPE_JOB_DESCRIPTION :
                        blockClasses.push('block-job');
                        htmlContent = blockData.list;

                        content = (
                            <JobBlock key={`content-block-index-${index}`} classes={blockClasses}
                                      content={htmlContent}/>
                        );
                        break;
                    case constantArticle.CONTENT_TYPE_VIDEO:
                        blockClasses.push('block-video');
                        //const videoUrl = blockData.content;
                        // EBE Ticket #3268 - deactivate suggested videos grid in the end of youtube's video
                        const videoUrl = blockData.content + '?rel=0&showinfo=0';

                        content = (
                            <div key={`content-block-index-${index}`} className={blockClasses.join(' ')}>
                                <div className="video-wrapper">
                                    <iframe title={`block-video-${index}`} width="1280" height="720" src={videoUrl}
                                            allow="autoplay; encrypted-media" allowFullScreen></iframe>
                                </div>
                                <div className="video-description">{blockData.description}</div>
                            </div>
                        );
                        break;
                    case constantArticle.CONTENT_TYPE_QUIZZ:
                        blockClasses.push('block-quizz');
                        const quizzId = blockData.quizz_id;
                        const isLastBlock = (index === this.props.content.blocks.length - 1);
                        let isCompleted = false;

                        // Ticket 3302
                        if (Object.keys(this.props.listQuizzes).length > 0 && this.props.listQuizzes.hasOwnProperty(quizzId) && Object.keys(this.props.listQuizzes[quizzId]).length > 0) {
                            if (this.props.listQuizzes[quizzId].quizzCompleted) {
                                isCompleted = true;
                            }
                        }

                        if (!isCompleted && !isLastBlock) {
                            lockedBlockMapping.push(quizzId);
                        }

                        content = <QuizzBlock
                            index={index}
                            blockClasses={blockClasses}
                            quizzId={quizzId}
                            isLastBlock={isLastBlock}/>;
                        break;
                    case constantArticle.CONTENT_TYPE_HTML:
                        blockClasses.push('block-html');
                        blockClasses.push(blockData.provider);

                        const embedContent = this.processHtmlContent(blockData.content);

                        content = (
                            <div key={`content-block-index-${index}`} className={blockClasses.join(' ')}
                                 dangerouslySetInnerHTML={{__html: embedContent}}/>
                        );
                        break;
                    default:
                        content = (
                            <div key={`content-block-index-${index}`} className={blockClasses.join(' ')}
                                 dangerouslySetInnerHTML={{__html: htmlContent}}/>
                        );
                        break;
                }

                const lastIndex = stickyLeft.length - 1;
                contentBlocks[lastIndex].push(content);

            });
        }

        return {stickyLeft, contentBlocks};
    };

    render() {

        //If the content is Empty
        if (Object.keys(this.props.content).length === 0) {
            return null;
        }

        //-- Get content left and right
        const {stickyLeft, contentBlocks} = this._defineContentOutput();

        let pageContent = (
            <Layout layoutClass="article-page">
                <Header classes='article-header' hasWideLogo='true'>
                    <ClickableIcon name="backBtn" class="icon-back-btn" iconPath={BackBtnArrow}
                                   action={this.backButtonClickHandler}/>
                    <TinyJellyShape color="#49d1e5"/>
                </Header>
                <main key={'that-my-main-bro'}>
                    <MessageModal
                        show={this.props.showBlockedCommentPopup}
                        closeModalHandler={this.closeModalHandler}
                        image="error"
                        message="Cette fonctionnalité n'est pas encore disponible"
                        zigzagColor="#49d1e5"
                        zigzagClass="blue-shape"
                    />
                    <Comment/>
                    <div key={'that-my-content-bro'} className={"main-content-blocks"}>
                        {this._renderContentBlocks(stickyLeft, contentBlocks)}
                    </div>
                </main>
                <Footer classes='article-footer'>
                    <ClickableIcon name="toggleMenu" class="icon-menu" iconPath={BurgerMenu}/>
                    <span>
                      {this.props.isUserSignedIn ?
                          <EmojiWheel articleId={this.props.content.id} closeWheel={this.state.closeReactionWheel}/>
                          :
                          <div className="avatar-container subscribe">
                          </div>
                      }
                    </span>
                    <ChatButton roomName={this.props.content.id} metaData={this.props.content.title} comment={true}
                                classes="icon-pencil"/>
                </Footer>
            </Layout>
        );

        if (!this.props.isUserSignedIn) {

            const tryoutPopup = (
                <div className="tryout-popup">
                    <div className="close-btn" onClick={this.onCloseTryOutPopup}></div>
                    <div className="logo"></div>
                    <div className="beware">Le site est réservé à nos abonnés</div>
                    <div className="title">Connecte-toi</div>
                    <div className="infos">Accède à tous nos contenus </div>

                    <Button
                        key='login'
                        name='login'
                        class='yellowBtn'
                        action={this.onClickGoToLogin}
                        disabled={false}>
                        Je me connecte
                    </Button>
                    <div className="blue-zigzag">
                        <Zigzag color="#49d1e5"/>
                    </div>
                    <div className="yellow-zigzag">
                        <Zigzag color="#ffde39"/>
                    </div>
                </div>
            )

            pageContent = (
                <Aux>
                    <div className="public-article block-action">
                        {tryoutPopup}
                    </div>
                    <div className="public-article blur">
                        {pageContent}
                    </div>
                </Aux>

            );
        }

        return (
            <Aux>
                {pageContent}
            </Aux>
        )
    }

}

const mapStateToProps = state => {
    return {
        showBlockedCommentPopup: state.article.showBlockedCommentPopup,
        //quizzCompletedStep : state.quizz.lastCompletedStep,
        listQuizzes: state.quizz.articleQuizzes,
        pathname: state.router.location.pathname,
        isUserSignedIn: state.auth.isUserSignedIn
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getArticle: (id) => {
            dispatch(getArticleContent(id))
        },
        getFakeArticle: (id) => dispatch(getFakeArticleContent(id)),
        onBackArticleClicked: () => {
            dispatch(goBack());
        },
        onCloseModal: () => dispatch(hideBlockedCommentPopup()),
        onCloseTryOutModal: () => dispatch(push('/discover')),
        goToDiscoverPage: () => dispatch(push('/discover')),
        goToContact: () => dispatch(push('/contact')),
        onClickGoLogin: () => dispatch(push('/login'))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleDetails);


// WEBPACK FOOTER //
// ./src/components/Article/Details/ArticleDetails.js